export const styles = theme => ({
  button: {
    whiteSpace: "nowrap"
  }
})



// WEBPACK FOOTER //
// ./src/components/RouteButton/styles.js